"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children", "color", "size", "disabled", "classes", "tag", "view", "active"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".c039a1fc0{outline:0;background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:inline-flex;position:relative;z-index:0}.c039a1fc0:after{content:'';transition:background var(--animation-timing-def) ease;top:0;left:0;bottom:0;right:0;position:absolute;z-index:-1;border-radius:.4375rem}.cca13fd58:not(.c146c070d){cursor:pointer}.cca13fd58:not(.c146c070d).c7960132d.cf09375c9:after{background:#edf2ff}.cca13fd58:not(.c146c070d).c7960132d:hover:after{background:#edf2ff}.cca13fd58:not(.c146c070d).c7960132d:active:after{background:0 0}.cca13fd58:not(.c146c070d).cf4c17eda.cf09375c9:after{background:var(--color-flomni-green-10)}.cca13fd58:not(.c146c070d).cf4c17eda:hover:after{background:var(--color-flomni-green-10)}.cca13fd58:not(.c146c070d).cf4c17eda:active:after{background:0 0}.cca13fd58:not(.c146c070d).c9f6487a4.cf09375c9:after{background:#f4f5f7}.cca13fd58:not(.c146c070d).c9f6487a4:hover:after{background:#f4f5f7}.cca13fd58:not(.c146c070d).c9f6487a4:active:after{background:0 0}.cca13fd58.c146c070d{cursor:default;opacity:.4}.c54088cc8{cursor:inherit}.c43e6272c{width:1.75rem;height:1.75rem}.c43e6272c svg{width:1.75rem;height:1.75rem}.cc0dcdbe7{width:1rem;height:1rem}.cc0dcdbe7 svg{width:1rem;height:1rem}.c7960132d{color:var(--color-flomni-blue-70)}.cf4c17eda{color:var(--color-flomni-green-70)}.c9f6487a4{color:var(--color-flomni-gray-70)}");
var styles = {
  root: 'c039a1fc0',
  '--view-usual': 'cca13fd58',
  '--disabled': 'c146c070d',
  '--color-blue': 'c7960132d',
  active: 'cf09375c9',
  '--color-green': 'cf4c17eda',
  '--color-gary': 'c9f6487a4',
  '--view-block': 'c54088cc8',
  '--size-usual': 'c43e6272c',
  '--size-small': 'cc0dcdbe7'
};

var IconButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames;

  var children = props.children,
      color = props.color,
      size = props.size,
      disabled = props.disabled,
      classes = props.classes,
      tag = props.tag,
      view = props.view,
      active = props.active,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement(tag, _objectSpread(_objectSpread({
    disabled: disabled,
    className: (0, _classnames.default)(cn.root, cn.color[color], cn.size[size], cn.view[view], (_classNames = {}, (0, _defineProperty2.default)(_classNames, cn.disabled, disabled), (0, _defineProperty2.default)(_classNames, cn.active, active), _classNames))
  }, rest), {}, {
    ref: ref
  }), children);
});

exports.IconButton = IconButton;
var color = ['blue', 'green', 'gary'];
var size = ['usual', 'small'];
var view = ['usual', 'block'];
IconButton.modes = {
  color: color,
  size: size,
  view: view
};
IconButton.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  disabled: _propTypes.bool,
  tag: _propTypes.string,
  active: _propTypes.bool,

  /* styling modificators */
  color: (0, _propTypes.oneOf)(color),
  size: (0, _propTypes.oneOf)(size),
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
IconButton.defaultProps = {
  active: false,
  tag: 'button',
  size: 'usual',
  color: 'blue',
  view: 'usual',
  disabled: false,
  classes: {}
};